import { useAuthStore } from '../../store/authStore';

export default function AccessDenied() {
  const { character, logout } = useAuthStore();

  return (
    <div className="flex h-full items-center justify-center bg-gray-900">
      <div className="max-w-md text-center p-8">
        <div className="mb-6 text-6xl">🚫</div>
        <h1 className="mb-4 text-2xl font-bold text-white">Access Denied</h1>
        <p className="mb-6 text-gray-400">
          Your character{' '}
          <span className="font-semibold text-blue-400">{character?.name}</span> is not on
          the whitelist. Please contact the administrator to request access.
        </p>
        <button
          onClick={() => logout()}
          className="rounded-lg bg-gray-700 px-6 py-3 font-semibold text-white transition hover:bg-gray-600"
        >
          Logout and Try Another Character
        </button>
      </div>
    </div>
  );
}
